<template>
    <div class="new_foot">
        <div class="foot_set soundSizeSet">
            <div class="new_foot_top">
                <div class="foot_weixin" style="margin-right:40px">
                    <div class="weiBackImg"></div>
                </div>
                <div class="company_fontSize">
                    <div class=" company_setLine_1" style="padding-top: 10px">
                        <div class="footpaddingImg footpaddingImg1" style="padding-left: 40px">上海麦图信息科技有限公司</div>
                        <div style="margin-left: 55px;padding-top: 3px;font-weight: normal;white-space: nowrap;">上海市普陀区真南路1199弄李园智创大厦6层</div>
                        <div style="margin-left: 55px;padding-top: 3px;font-weight: normal">上海市普陀区灵石路1188号</div>
                    </div>
                    <div class="" style="opacity: 0.6;font-size: 14px;padding-top: 10px">
                        <div class="footpaddingImg footpaddingImg2" style="padding-left: 30px">北京</div>
                        <div class="footpaddingImg footpaddingImgNull" style="padding-top: 3px">北京悠数智能科技有限公司
                        </div>
                        <div class="footpaddingImg footpaddingImgNull" style="padding-top: 3px">
                            北京市朝阳区化工路59号院4号楼焦奥中心5层696室</div>
                    </div>
                    <div class="" style="opacity: 0.6;font-size: 14px;padding-top: 10px">
                        <div class="footpaddingImg footpaddingImg2" style="padding-left: 30px">广州</div>
                        <div class="footpaddingImg footpaddingImgNull" style="padding-top: 3px">麦图科技广州分公司</div>
                        <div class="footpaddingImg footpaddingImgNull" style="padding-top: 3px">广州市白云区云城东路565号宏鼎云璟汇1号楼1117室</div>
                    </div>
                </div>

                <!-- <div class="line"></div> -->
                <!-- <div class="company_connnect_us" style="padding-top: 10px">
                    <div class="company_setLine_1">广州</div>
                    <div class="footpaddingImg footpaddingImg4 company_setLine_2"
                        style="margin-top:0px;margin-left: 0;font-size: 14px">400-921-6230</div>
                    <div class="footpaddingImg footpaddingImg3 company_setLine_2"
                        style="margin-top:3px;margin-left: 0;font-size: 14px">info@youzidata.com</div>
                </div> -->
                <!-- <div class="footpaddingImg footpaddingImg1">上海麦图信息科技有限公司</div>
        <div class="footpaddingImg footpaddingImg2">400-921-6230</div>
        <div class="footpaddingImg footpaddingImg3">info@youzidata.com</div>-->
            </div>
        </div>
        <!-- <div style="width:100%;height:40px"></div> -->
        <div class="foot_bottom_absolute">
            <div class="foot_content" style="font-size: 12px;color: #999999">
                <span class="me ">联系我们</span>
                <img class="call marL20" src="../../../common/commonImages/new_4.png" alt="">
                <span class="marL6">400-921-6230</span>
                <img class="foot_emil marL20" src="../../../common/commonImages/new_5.png" alt="">
                <span class="marL6">info@youzidata.com</span>
                <span class="marL40">© Copyright</span>
                <span>youzidata.com</span>
                <span>2015-{{newYear}}</span>
                <span>沪ICP备140076292号-7</span>
            </div>
        </div>
    </div>
</template>
<style>
.line{
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  width: 1px;
  height: 66px;
  margin-top: 12px;
}
.company_connnect_us {
  padding-left: 30px;
  margin-left: 30px;
  height: 82px;
}
.foot_bottom_absolute {
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #424242;
  height: 36px;
  bottom: 0;
}
.foot_content{
    display: flex;
    align-items: center;
    line-height: 1;
}
.marL6{
    margin-left: 8px;
}
.marL20{
    margin-left: 20px;
}
.marL40{
    margin-left: 40px;
}
.me{
    color: #fff;
    font-weight: bold;
    font-size: 14px;
}
.call{
    height: 14px;
}
.foot_emil{
    height: 12px;
}
.new_foot {
  flex-direction: column;
  position: relative;
  padding-bottom: 32px;
}
.company_setLine {
  font-weight: 100;
  /* opacity: 0.6; */
}
.company_setLine_1 {
  font-weight: bold;
  opacity: 1;
  font-size: 14px !important;
}
.company_setLine_2 {
  font-weight: 100;
  opacity: 0.6;
}
.company_fontSize {
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.company_setLine {
  display: flex;
}
.foot_set {
  width: 1200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.new_foot_bottom > span {
  margin: 0 7px;
}
.footpaddingImg {
  padding-left: 30px;
  background: url("../../../common/commonImages/new_1.png") no-repeat;
  background-size: 27px 21px;
  margin-left: 15px;
  background-position-y: center;
  background-position-x: left;
}
.footpaddingImg1 {
  background: url("../../../common/commonImages/new_3.png") no-repeat;
  background-size: 21px 18px;
  background-position-y: center;
}
.footpaddingImg2 {
  background: url("../../../common/commonImages/new_43.png") no-repeat;
  background-size: 15px 21px;
  background-position-y: center;
}
.footpaddingImg3 {
  background: url("../../../common/commonImages/new_5.png") no-repeat;
  background-size: 22px 14px;
  background-position-y: center;
}
.footpaddingImg4 {
  background: url("../../../common/commonImages/new_4.png") no-repeat;
  background-size: 20px 20px;
  background-position-y: center;
}
.footpaddingImgNull {
  background: url("") no-repeat;
}
.new_foot {
  background-color: #4d4d4d;
}
.foot_weixin {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.new_foot_top {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
}
.weiBackImg {
  width: 90px;
  height: 90px;
  background: url("../assets/ucode.png") no-repeat;
  background-size: 100%;
}
</style>
<script>
export default {
  name: "Footer",
  data() {
    return {
      newYear: new Date().getFullYear()
    };
  },
  created: function() {},
  mounted: function() {},
  methods: {
    joinFn: function() {
      window.scrollTo(0, 0);
      this.$router.push({ path: "join" });
    },
    pratnerFn() {
      setTimeout(() => {
        window.scrollTo(0, 5000);
      }, 100);

      this.$router.push({ path: "about" });
    }
  }
};
</script>
